module.exports = __webpack_public_path__ + "static/media/side-image.2f8150f9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/UserLogIn/images/side-image.jpeg
// module id = 16
// module chunks = 0